const data = {
  pageName: "FixedSameTariff",
  services: {
    translations: {
      url: "offers/fixedsametariff/translations",
      params: {}
    },
    createServiceRequest: {
      url: "offers/dsl2vdsl/createServiceRequest",
      params: {}
    },
    checkAvailability: {
      url: "offers/fixedsametariff/offer",
      params: {}
    },
    createProductOrder: {
      url: "offers/fixedsametariff/e2e",
      params: {}
    },
    checkClickToCallRequest: {
      url: "clickToCall/checkClickToCallRequest",
      params: {}
    },
    checkClickToCallAvailability: {
      url: "clickToCall/checkClickToCallAvailability"
    }
  },
  asset: {
    body: null,
    callinglist: "callingList",
    click2callButtons: "click2callButtons",
    clicktocallid: "clickTocallId",
    clicktocallphone: "clickToCallPhone",
    clicktocallversion: "clickToCallVersion",
    clicktocallcalendar: "clickToCallCalendar",
    formId: "redStart",
    description: "",
    name: "NewLineUpRedStart",
    subtype: "Forms",
    updateddate: "2020-02-26T12:28:46+0000"
  },
  externalLinks: {
    askHelp: "/exypiretisi/my-vodafone/ananeosi-symvolaiou/",
    otpPage: "/ananeosi-statheris/",
    questionnaire: "/retention-fixed-journey-rating/"
  }
};
exports.data = data;
